export default "__VITE_ASSET__dc3d426e__"